import withFraction from "./withFraction";

export default function createSchemaObject(recipe) {
  const { intro, ingredients, instructions, settings } = recipe;
  let schemaObject = {
    "@context": "https://schema.org/",
    "@type": "Recipe",
    "name": intro.title,
    "image": intro.images,
    "author": {
      "@type": "Person",
      "name": intro.author
    },
    "datePublished": "2018-03-10",
    "description": intro.description,
    "prepTime": `PT${intro.prepTime}M`,
    "cookTime": `PT${intro.cookTime}M`,
    "totalTime": `PT${intro.totalTime}M`,
    "keywords": intro.keywords,
    "recipeYield": settings.baseServingSize,
    "recipeCategory:": intro.recipeCategory,
    "recipeCuisine": intro.cuisine,
    "recipeIngredient": [],
    "recipeInstructions": [
      {
        "@type": "HowToStep",
        "name": "Preheat",
        "text": "Preheat the oven to 350° F. Grease and flour a 9x9 inch pan.",
        "url": "https://example.com/party-coffee-cake#step1",
        "image": "https://example.com/photos/party-coffee-cake/step1.jpg"
      }
    ]
  }

  // add ingredients
  ingredients.forEach(section => {
    section.items.forEach(item => {
        // Concatenate item details into a single string
        let itemString = '';
        if (item.number) itemString += withFraction(item.number) + ' ';
        if (item.unit) itemString += item.unit + ' ';
        itemString += item.name;
        if (item.preparation) itemString += ' (' + item.preparation + ')';
        if (item.note) itemString += ' - ' + item.note;

        // Add item schemaObject
        schemaObject.recipeIngredient.push(itemString.trim());
    });
  });

  // generate properly formatted instructions array
  function generateInstructionsArray(instructions) {
    return instructions.map(section => {
        return {
            "@type": "HowToSection",
            "name": section.name,
            "itemListElement": section.steps.map(step => {
                return {
                    "@type": "HowToStep",
                    "text": step.text.replace(/[#*]/g, '')
                }
            })
        };
    });
  }

  // add instructions array to schemaObject
  schemaObject.recipeInstructions = generateInstructionsArray(instructions);

  return JSON.stringify(schemaObject)
}